package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{EditableWordStateProvider, RecordingSegment, RecordingTranscriptReviewState, RecordingTranscriptReviewStateGenerator, TestTranscriptReviewStateGenerator}
import com.neurobs.ccabserver.transcriptreview.util.EditableTranscriptWord
import com.neurobs.util.TimeSeconds
import org.scalajs.dom.{AudioBuffer, console}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html._
import slinky.core.facade.Hooks._

@react
object ReviewableTranscript {

	case class Props(audioDuration: TimeSeconds)

	val component = FunctionalComponent[Props] { props =>

		val recordingTranscriptReviewState = RecordingTranscriptReviewStateGenerator.accessState
		val testState = TestTranscriptReviewStateGenerator.accessState

		def reviewHandler = recordingTranscriptReviewState.handler

		def generateStyle = {
			StyleUtil.makeStyle(
				("width", testState.secondsToPixels(props.audioDuration) + "px"),
				("height", "20px"),
				("transformOrigin", "0 0"),
				("transform", testState.getTransformStyle),
				("marginBottom", "10px"),
				("marginTop", "40px")
			)
		}

		def reviewableWordKey(word: EditableTranscriptWord) = s"${word.word}_${word.startTime}"

		def reviewableWordComponent(editableWord: EditableTranscriptWord) = {
			EditableWordStateProvider(
				editableWord = editableWord
			)(
				ReviewableWord()
			)
		}

		div(
		style := generateStyle
		)(
			reviewHandler.reviewingTranscript.transcriptWords.map(editableWord => {
				reviewableWordComponent(editableWord).withKey(reviewableWordKey(editableWord))
			})
		)
	}
}

